export const definedTranslation = {
  placeholders: {
    noProject: {
      id: 'search-form-no-project-placeholder',
      defaultMessage: 'Search items for your next project',
    },
    project: {
      id: 'search-form-project-placeholder',
      defaultMessage: 'Search items for {project}',
    },
    inspiration: {
      id: 'search-form-inspiration-placeholder',
      defaultMessage:
        'Search modern interiors, inventive exteriors, archival books and more',
    },
  },
  newLabel: {
    id: 'search-form-new-label',
    defaultMessage: 'New',
  },
  visualSearch: {
    searchTooltip: {
      id: 'visual-search-search-tooltip',
      defaultMessage: 'Search by image',
    },
    uploadModal: {
      defaultTooltip: {
        id: 'visual-search-upload-modal-default-tooltip',
        defaultMessage: 'Search by Image',
      },

      title: {
        id: 'visual-search-upload-modal-title',
        defaultMessage: 'Material Bank Match',
      },
      subtitle: {
        id: 'visual-search-upload-modal-subtitle',
        defaultMessage:
          'Unleash the power of visual search. Upload an image and see similar items available for sampling.',
      },
      dropzoneText: {
        id: 'visual-search-upload-modal-dropzone-text',
        defaultMessage: 'Drag an image here or',
      },
      dropzoneButton: {
        id: 'visual-search-upload-modal-dropzone-button',
        defaultMessage: 'Upload a file',
      },
      or: {
        id: 'visual-search-upload-modal-or-label',
        defaultMessage: 'or',
      },
      placeholder: {
        id: 'visual-search-upload-modal-placeholder',
        defaultMessage: 'Paste image link',
      },
      button: {
        id: 'visual-search-upload-modal-button',
        defaultMessage: 'Search',
      },
      uploading: {
        id: 'visual-search-upload-modal-uploading-status',
        defaultMessage: 'Uploading',
      },
      errors: {
        wrongType: {
          id: 'visual-search-upload-modal-errors-wrong-type',
          defaultMessage: 'File type must be one of',
        },
        tooManyFiles: {
          id: 'visual-search-upload-modal-errors-too-many-files',
          defaultMessage: 'Too many files',
        },
        imageNotFound: {
          id: 'visual-search-upload-modal-errors-image-not-found',
          defaultMessage: "Couldn't find image at the specified address",
        },
        someError: {
          id: 'visual-search-upload-modal-errors-some-error',
          defaultMessage: 'Some error occurred, please try again',
        },
      },
    },
    resultsModal: {
      title: {
        id: 'visual-search-results-modal-title',
        defaultMessage: 'Visual Search',
      },
      matches: {
        id: 'visual-search-results-modal-matches-title',
        defaultMessage: 'Product Matches',
      },
    },
  },
};
